import { v4 as uuidv4 } from "uuid";

export const formatDate = (date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const generate24HourData = () => {
  const data = [];
  const now = new Date();

  for (let i = 0; i <= 24; i++) {
    const timestamp = new Date(now.getTime() - i * 60 * 60 * 1000); // Subtract hours
    const value = Math.floor(Math.random() * 100); // Random value
    data.push([timestamp.getTime(), value]);
  }

  return data.reverse(); // Ensure ascending order
};

export const getThemeColor = () => {
  const theme = window.localStorage.getItem("theme");

  switch (theme) {
    case "default":
      return "#1890ff";
    case "charcoal":
      return "#36454F";
    case "emeraldGreen":
      return "#00674F";
    default:
      return "#1890ff";
  }
};

export const generateRandomKey = () => {
  return uuidv4();
};

export const formatToTrillions = (num) => {
  const trillion = 1e12;
  if (num >= trillion) {
    return (num / trillion).toFixed(3) + "T";
  }
  return num.toString();
};
